import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import NewNavigation from './NewNavigation';
import ErrorBoundary from '../ui/ErrorBoundary';

const Layout = () => {
  const location = useLocation();
  return (
    <div className="min-h-screen flex flex-col">
      {/* Skip Navigation - WCAG 2.1 AA */}
      <a
        href="#main-content"
        className="sr-only focus:not-sr-only focus:absolute focus:top-2 focus:left-2 focus:z-50 focus:px-4 focus:py-2 focus:bg-blue-600 focus:text-white focus:rounded"
      >
        Skip to main content
      </a>

      {/* New Navigation */}
      <NewNavigation />

      {/* Main Content — issue #286: shared container so all in-app pages
          have consistent alignment. Pages should NOT self-wrap with their
          own max-w-7xl / mx-auto / px-* / py-* anymore. */}
      <main id="main-content" className="flex-1 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
          {/* #370 — route-level boundary: a page crash shows a recoverable
              pane while the nav shell stays alive. Keyed by pathname so
              navigating away automatically clears the error state. */}
          <ErrorBoundary variant="section" name="route" key={location.pathname}>
            <Outlet />
          </ErrorBoundary>
        </div>
      </main>

      {/* Footer */}
      <footer className="py-4 border-t bg-white">
        <div className="container mx-auto px-4 text-center text-gray-600 text-sm">
          &copy; {new Date().getFullYear()} Finnewsy. All rights reserved.
        </div>
      </footer>
    </div>
  );
};

export default Layout; 